import {
  ComboBox,
  IComboBox,
  IComboBoxOption,
  IComboBoxProps,
  IRefObject,
  Label,
} from "@fluentui/react";
import { KeyboardEventHandler } from "react";

interface IComboBoxIDS extends IComboBoxProps {
  componentRef?: IRefObject<IComboBox>;
  onClick?: () => void;
  KeyUp?: KeyboardEventHandler<IComboBox> | undefined;
  value?: string
  onChange?: (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ) => void;

  title?: string;
  useComboBoxAsMenuWidth?: boolean;
}

export const ComboBoxIDS = (props: IComboBoxIDS) => {
  const { title, KeyUp, onChange, onClick, ...comboBoxProps } = props;

  return (
    <div>
      <Label>{props.title}</Label>
      <ComboBox
        autoComplete={"off"}
        componentRef={props.componentRef}
        allowFreeform
        openOnKeyboardFocus
        useComboBoxAsMenuWidth={
          props.useComboBoxAsMenuWidth != null &&
            props.useComboBoxAsMenuWidth != undefined
            ? props.useComboBoxAsMenuWidth
            : true
        }
        onKeyUp={props.KeyUp}
        onChange={props.onChange}
        onClick={props.onClick}
        {...comboBoxProps}
      />
    </div>
  );
};
